import { productService } from '@/services/api'

const initialStates = {
    status: 'LOADING',
    productsList: {},
    priceRange: {},
    pagination: {
        no_paginate: false,
        per_page: 20,
        current_page: 1,
        last_page: 1,
    },
    filtersSet: {
        store_id: {
            label: 'فروشگاه',
            value: ''
        },
        name: {
            label: 'نام',
            value: ''
        },
        product_group_id: {
            label: 'دسته بندی',
            value:''
        }
    },
    filters:{
        name: '',
        in_stock: '',
        has_discount: '',
        store_id: '',
        product_group_id: '',
        min_price: 0,
        max_price: 0
    }
}

const mutations = {
    loading(state) {
        state.status = 'LOADING'
    },
    setPriceRange(state, Range) {
        state.status = 'SET_LIST'
        state.priceRange = Range
        state.filters.min_price = Range.price.min
        state.filters.max_price = Range.price.max
    },
    setProductsList(state, products) {
        state.status = 'SET_LIST'
        state.productsList = products
    },
    setPagination(state, pagination) {
        state.status     = 'SET_PAGINATION'
        state.pagination = Object.assign({}, state.pagination, pagination)
    },
}

const getters = {
    priceRange: state => state.priceRange,
    products: state => state.productsList,
    pagination: state => state.pagination,
    filters: state => state.filters,
    filtersSet: state => state.filtersSet,
}

const actions = {
    fetch({commit}, params) {
        commit('loading')

        return new Promise((resolve, reject) => {
            productService.fetch(params)
            .then(response => {
                const result = response.data
                commit('setProductsList', result.data)
                commit('setPagination', {
                    per_page: result.per_page,
                    current_page: result.current_page,
                    last_page: result.last_page,
                })
                resolve(result)
            })
            .catch(error => {
                commit('error')
                reject(error.response ? error.response.data : error.response)
            })
        })
    },
    fetchPriceRange({commit}) {
        commit('loading')

        return new Promise((resolve, reject) => {
            productService.fetchPriceRange()
                .then(response => {
                    const result = response.data
                    commit('setPriceRange', result.data)
                    resolve(result)
                })
                .catch(error => {
                    commit('error')
                    reject(error.response ? error.response.data : error.response)
                })
        })
    },
    resetProduct({commit}){
        commit('setProductsList', {})
    }
}

export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}